// Collection ID constants used across HR and CMS collection pages

export const CENSUS_ID_1940 = '2000219'
export const CENSUS_ID_1950 = '4464515'
export const IGI_ID = '5'

// IGI-specific wiki link
export const IGI_WIKI_LINK = '/wiki/en/International_Genealogical_Index_(IGI)_-_FamilySearch_Historical_Records'

// US Census collection IDs (1910–1950) — flag-gated for isolated CMS page release
export const US_CENSUS_CMS_COLLECTION_FLAG_IDS = new Set([
  '1727033', // 1910
  '1488411', // 1920
  '1810731', // 1930
  '2000219', // 1940
  '4464515', // 1950
])

// Collections released under search_cmsCollectionsWikiCollections flag (FSS-13587)
export const WIKI_COLLECTION_IDS = new Set([
  '5000145', // United States, Obituary Records, 2014-2023
  '2333694', // United States, GenealogyBank Obituaries, Births, and Marriages 1980-2014
  '1949342', // Texas Birth Index, 1903-1997
  '1743384', // Alabama County Marriages, 1809-1950
  '2370234', // Virginia, Marriage Certificates, 1936-1988
  '2860782', // United States, GenealogyBank Historical Newspaper Obituaries, 1815-2011
  '1949334', // Minnesota Birth Index, 1935-2002
  '1614804', // Ohio, County Marriages, 1789-2016
  '1921547', // England and Wales Census, 1911
  '1726957', // North Carolina, County Marriages, 1762-1979
  '1325221', // United States Census, 1900
  '1417683', // United States Census, 1880
  '1438024', // United States Census, 1870
  '1473181', // United States Census, 1860
  '1401638', // United States Census, 1850
])
